import axios from "axios";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { getAccessToken } from "./utils";
import moment from "moment";
import { formatTopicsSubtopics } from "../lib/formatFilter";

export const toggleAdvFiltersColumn = (arg) => {
    return {
        type: "TOGGLE_ADV_FILTERS_COLUMN",
        payload: arg,
    };
};

export const createAdvanceDashboard = (data) => {
    let url = `${getUrl("dashboardCreate")}`;
    let req = axios({
        method: "POST",
        url: url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Advance Dashboard created successfully");
            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: "CREATE_ADVANCE_DASHBOARD",
        payload: req,
    };
};

export const advanceChartConfiguration = (arg) => {
    return {
        type: "CHART_CONFIGURATION_VALUE",
        payload: arg,
    };
};

export const updateAdvanceChartDimension = (arg) => {
    return {
        type: "UPDATE_DIMENSION_NAME",
        payload: arg,
    };
};
export const advanceChartEditStatus = (arg) => {
    return {
        type: "EDIT_CHART_EDIT_STATUS",
        payload: arg,
    };
};

export const getTopTenTopicicsByDataUsage = () => {
    let data = {
        apply_exclusion: "no",
        image_analytics_types: [],
    };
    let tz = JSON.parse(localStorage.company).user_timezone_name;

    data.end_date = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
    data.start_date = moment(new Date()).subtract(7, "days").tz(tz).format("YYYY-MM-DDTHH:mm:ss");
    let topicsList = formatTopicsSubtopics({ filter_data: { topics: ["ALL"], subtopics: [] } }, false);
    data.topic_data = topicsList;

    let url = `${getUrl("searchaggs")}&apiWrapperIdentifiers=dataBySubTopic`; //dataByTopic

    let response = axios({
        method: "POST",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return error;
        });
    return {
        type: "TOP_TOPICS_BY_DATA",
        payload: response,
    };
};
export const editAdvanceChartConfiguration = (arg) => {
    return {
        type: "EDIT_CHART_CONFIGURATION_VALUE",
        payload: arg,
    };
};

export const editAdvanceChartName = (arg) => {
    return {
        type: "EDIT_CHART_CONFIGURATION_NAME",
        payload: arg,
    };
};
export const editAdvanceWidgetChartConfiguration = (arg) => {
    return {
        type: "EDIT_CHART_WIDGET_CONFIGURATION",
        payload: arg,
    };
};

export const addOnClickDimension = (arg) => {
    return {
        type: "ADD_DIMENSION_ON_CLICK",
        payload: arg,
    };
};
export const addOnClickMetric = (arg) => {
    return {
        type: "ADD_METRIC_ON_CLICK",
        payload: arg,
    };
};
